import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@adsk/bim360-matrix-react-loader';
import {historyAttributesType} from '../constants/proptype-validation';
import {getAppLoading, getTargetUrn} from '../app/selectors';
import {connect} from '../app/connect';
import NotificationManagerWrapper from './common/NotificationManagerWrapper';
import RoutesContainer from './RoutesContainer';

const AppLoading = ({history, loading, preventLoader}) => loading && !preventLoader ?
  <Loader /> :
  <NotificationManagerWrapper>
    <RoutesContainer history={history} />
  </NotificationManagerWrapper>;

AppLoading.propTypes = {
  loading: PropTypes.bool.isRequired,
  preventLoader: PropTypes.bool.isRequired,
  history: historyAttributesType.isRequired
};

AppLoading.displayName = 'AppLoading';

const mapStateToProps = state => ({
  key: getTargetUrn(state),
  loading: getAppLoading(state)
});

export default connect(mapStateToProps)(AppLoading);
